import useOverlay from "@/hooks/common/useOverlay";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/detailpackage/hotelguide";
import {GuideSlideImg} from "@COMPONENTS/style/slide";
import {EditorBox} from "@FRAMEWORK/ui/desktop/editor";
import {GuideSlide} from "@FRAMEWORK/ui/desktop/slide";
import {SubTitle} from "@FRAMEWORK/ui/desktop/text";
import useEventHotelResort, {EventHotelResort} from "@QUERIES/prdt/event/useEventHotelResort";
import useEventInfoImages from "@QUERIES/prdt/event/useEventInfoImages";
import useEventInfoVideos from "@QUERIES/prdt/event/useEventInfoVideos";
import {useState} from "react";
import {SwiperSlide} from "swiper/react";
import {Noimage} from "@yb/ui/desktop/common/Noimage";
import ImageVideoPop from "../popup/ImageVideoPop";

const HotelResortImagesComponent = (props: EventHotelResort & {evCd: string}) => {
	const {accommInfoId, evCd} = props;
	const hotelImagesFetch = useEventInfoImages(accommInfoId, "hotel", evCd);
	const hotelVideoFetch = useEventInfoVideos(accommInfoId, "hotel", evCd);
	const images = hotelImagesFetch.data?.body || [];
	const videos = hotelVideoFetch.data?.body || [];

	const [open] = useOverlay();
	const handleImageVideoPop = () => {
		open(prop => <ImageVideoPop {...prop} images={images} videos={videos} title="호텔/리조트 이미지 상세보기" />);
	};

	return (
		<>
			{images.length + videos.length > 0 && (
				<GuideSlide perView={2} spaceBetween={12}>
					{videos.length > 0 &&
						videos.map((item, index) => (
							<SwiperSlide key={`video${index}`}>
								<GuideSlideImg types="movie" onClick={handleImageVideoPop}>
									<Noimage width="100%" height="283px" src={item.vimeoThum1} alt={item.vimeoNote} />
								</GuideSlideImg>
							</SwiperSlide>
						))}
					{images.length > 0 &&
						images.map((item, index) => (
							<SwiperSlide key={`image${index}`}>
								<GuideSlideImg onClick={handleImageVideoPop}>
									<Noimage width="100%" height="283px" src={item.imageThum2} alt={item.imageNote} />
								</GuideSlideImg>
							</SwiperSlide>
						))}
					{images.length + videos.length === 1 && (
						<SwiperSlide key="noImg">
							<GuideSlideImg>
								<Noimage width="100%" height="283px" src="" alt="" />
							</GuideSlideImg>
						</SwiperSlide>
					)}
				</GuideSlide>
			)}
		</>
	);
};

const HotelResortImages = (props: EventHotelResort & {evCd: string}) => (
	<ErrorBoundary logMsg="HotelResort HotelResortImages Error">
		<HotelResortImagesComponent {...props} />
	</ErrorBoundary>
);

const HotelResortComponent = ({evCd}: {evCd: string}) => {
	const hotelResortFetch = useEventHotelResort(evCd);
	const hotelResort = hotelResortFetch.data?.body;

	const [active, setActive] = useState<number | null>(0);

	return (
		<>
			{hotelResort && hotelResort.length > 0 && (
				<style.Wrap>
					<SubTitle>호텔/리조트</SubTitle>
					<style.Tab>
						{hotelResort.map((item, index) => (
							<style.TabItem active={active === index} onClick={() => setActive(index)} key={index}>
								{item.tabNm}
							</style.TabItem>
						))}
					</style.Tab>

					{hotelResort.map((item, index) => (
						<style.HotelInfoWrap key={index} active={active === index}>
							<h4>{item.korNm}</h4>
							{/* 이미지 */}
							<HotelResortImages {...item} evCd={evCd} />
							<EditorBox margin={"40px 0 0"}>
								<table>
									<caption>호텔/리조트 정보</caption>
									<colgroup>
										<col style={{width: "15%"}} />
										<col style={{width: "85%"}} />
									</colgroup>
									<tbody>
										{item?.benfInfo && (
											<tr>
												<th scope="row">혜택 / 특전</th>
												<td>
													<EditorBox dangerouslySetInnerHTML={{__html: item.benfInfo}} />
												</td>
											</tr>
										)}
										{item?.amenityInfo && (
											<tr>
												<th scope="row">편의시설</th>
												<td>
													<EditorBox dangerouslySetInnerHTML={{__html: item.amenityInfo}} />
												</td>
											</tr>
										)}
										{item?.restaurantInfo && (
											<tr>
												<th scope="row">레스토랑</th>
												<td>
													<EditorBox dangerouslySetInnerHTML={{__html: item.restaurantInfo}} />
												</td>
											</tr>
										)}
										{item?.activityInfo && (
											<tr>
												<th scope="row">액티비티</th>
												<td>
													<EditorBox dangerouslySetInnerHTML={{__html: item?.activityInfo}} />
												</td>
											</tr>
										)}
										{item?.kidsOnlyServ && (
											<tr>
												<th scope="row">키즈전용</th>
												<td>
													<EditorBox dangerouslySetInnerHTML={{__html: item.kidsOnlyServ}} />
												</td>
											</tr>
										)}
										{item?.etcInfo && (
											<tr>
												<th scope="row">기타 안내</th>
												<td>
													<EditorBox dangerouslySetInnerHTML={{__html: item.etcInfo}} />
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</EditorBox>
						</style.HotelInfoWrap>
					))}
				</style.Wrap>
			)}
		</>
	);
};

const HotelResort = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="HotelResort Error">
		<HotelResortComponent {...props} />
	</ErrorBoundary>
);

export default HotelResort;
